module.exports = __webpack_public_path__ + "img/03.4ebcd33b.png";